import * as actions from '../../ActionsConst';
import helpers from './Helpers';

const cart = (state = 0, action) => {
  switch (action.type) {
    case actions.CART_UPDATE:
      return helpers.cartUpdate(action);
    default:
      return state;
  }
};

export default cart;
